import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from '../../config/environment';
import { Config } from '../../config/config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultaTransaccionService {

  constructor(private http: HttpClient, private Conf: Config) { }

  public searchLogExternal(data: any): Observable<any> {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'searchLogExternal';

    return this.http.post(url, data, httpOptions);
  }
}
